import React from 'react';
import { useEffect, useRef, useState } from "react";

import {
  Button,
  TextInput,
  FieldLabel,
  Icon,
  css,
  Grid,
  Div,
  Tooltip,
  GridCell,
  theme,
} from "@bdfx/fukit"
import ctrans from "../trans"

interface Props {
  feed_url: string
  setFeedUrl: Function
  conversion_url: string
  setConversionUrl: Function
  showModal: Function
  element: string
  setElement: Function

  sortimentFile: any
  setSortimentFile: Function
}

function Form(props: Props) {

  const { feed_url, setFeedUrl, conversion_url, setConversionUrl, element, setElement, showModal, setSortimentFile, sortimentFile } = props


  const inputRef = useRef(null);
  const handleChange = (e) => {
    if(setSortimentFile) {
      setSortimentFile(e.target.files[0]);
    } else {
      console.log('has no setSortimentFile', e)
    }
  };

  useEffect(() => {
    inputRef.current.addEventListener("input", handleChange);
  }, []);
  

  console.log(sortimentFile)
  return (
    <Content className="content">
      <FieldLabel htmlFor="heureka_sortiment_report_file" bold={true}>

        <Div margin="auto" border="1px dashed #ccc" borderRadius="5px" textAlign="center" padding="50px" cursor="pointer"
          {...{ ":hover": { background: "#f7f7f7", } }} >


          {ctrans("sortiment_report_label")}
          <Tooltip content={ctrans("sortiment_report_hint")}><Icon color="#ccc" size={20} type="hint-info" /></Tooltip>
          <Div marginTop="20px" marginBottom="0px" style={{ cursor: "pointer" }}>
            <Grid cols={sortimentFile ? "auto auto auto" : "1fr"} gap="20px" valign="center" align="center">
              <Icon type="upload-radix" size={40} />

              {sortimentFile ?
                <>
                  <span style={{ color: theme.blue }}>{sortimentFile?.name ?? ""}</span>
                  <span><Button size="small" simple={true} style={{ ":hover": { background: "#ffbbbb" } }} color="red" icon="close" onClick={(e) => { e.preventDefault(); setSortimentFile(null); e.stopPropagation(); return false; }} /></span>
                </> : null}
            </Grid>
          </Div>

          <input style={{ cursor: "pointer", display: "none", }} type="file" id="heureka_sortiment_report_file"  ref={inputRef} />
        </Div>

      </FieldLabel>
      <Icon className="arrow" size={30} type="chevron-down-light" color="#ddd" />
      <Grid cols={process.env.APP === "pricing" ? "1fr 1fr" : "1fr"} gap="20px" className="optional">
        <Div>
          <FieldLabel htmlFor="feed_url">{ctrans("feed_url_label")}: <Tooltip content={ctrans("feed_url_hint")}><Icon color="#ccc" size={20} type="hint-info" /></Tooltip></FieldLabel>
          <TextInput placeholder="Nepovinné" id="feed_url" value={feed_url} onChange={setFeedUrl} />
        </Div>
        {process.env.APP === "pricing" ?
          <Div>
            <FieldLabel htmlFor="element">{ctrans("element_label")}: <Tooltip content={ctrans("element_hint")}><Icon color="#ccc" size={20} type="hint-info" /></Tooltip></FieldLabel>
            <TextInput placeholder="Nepovinné" id="element" value={element} onChange={setElement} />
          </Div>
          :
          null}
      </Grid>
      {/* </>
            : null } */}
      <Button className="action-button" color="green" size="big" onClick={showModal}>{ctrans("continue")}</Button>
    </Content>
  );
}

const Content = css("div")({
  maxWidth: "800px",
  margin: "auto",
  padding: "6em 0 4em",
  ".optional .fuk-field-label": {
    marginBottom: "0.5rem",
    fontSize: "1.2rem",
  },
  "#conversion_url": {
    fontSize: "20px",
    height: "50px",
    lineHeight: "50px",

  },
  ".action-button": {
    fontWeight: "bold",
  },
  ".fuk-tooltip": {
    float: "right",
  },
  ".muk-popuphint": {
    float: "right",
  },

  ".fuk-field-label": {
    fontSize: "1.4em",
    marginBottom: "1em",
  },

  ".arrow": {
    margin: "1.5em 0 2.5em",
  },

  ".fuk-button": {
    margin: "2em 0",
  },
})

export default Form;
